
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'IconInfo',
  props: {
    width: {
      type: [String, Number] as PropType<string | number>,
      default: 16,
    },
    height: {
      type: [String, Number] as PropType<string | number>,
      default: 17,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
});
